import { useAllCrmStatusesCall } from "app/pages/sales-intelligence/sub-modules/management/hooks/useAllCrmStatusesCall";

export const useTeamFiltersBootstrap = (): void => {
    useAllCrmStatusesCall();
};
